class MCMediaWithContent extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      controls: '[data-controls]',
      siteHeader: '.section-header',
      tabs: '[data-tabs]',
      video: '.js-video'
    }

    this.classes = {
      active: 'active',
      hidden: 'hidden',
      isFixed: 'is-fixed',
      videoIsHalved: 'video--is-halved'
    }

    this.data = {
      collectionHandle: 'collectionHandle',
      section: 'section',
      videoPlaybackRate: 'videoPlaybackRate'
    }

    this.controls = this.querySelector(this.selectors.controls);
    this.tabs = this.querySelectorAll(this.selectors.tabs);
    this.videos = [...this.querySelectorAll(this.selectors.video)];
    this.videoIsPlaying = false;
    this.videoIsFinishing = false;
    this.videoPlaybackRate = parseFloat(this.dataset[this.data.videoPlaybackRate] || 1);
    this.currentVideo = this.videos.find(v => v.classList.contains(this.classes.active));    
    this.mqlSmall = window.matchMedia('screen and (max-width: 749px)');
    this.throttledOnScroll = throttle(this.onScroll, 50);

    this.playVideo();
    this.setupControls();
    this.initEvents();
    this.manageScrollEvent();
    
  }

  collectionChangeUnsubscriber = undefined;

  connectedCallback() {
    this.collectionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.collectionChange, (event) => {
      if (event.data.sectionId == this.dataset[this.data.section]) return;
      const collectionHandle = event.data.collectionHandle;
      this.playVideo(collectionHandle);
      this.openTabs(collectionHandle);
    });
  }

  disconnectedCallback() {
    if (this.collectionChangeUnsubscriber) {
      this.collectionChangeUnsubscriber.unsubscribe();
    }
  }

  setupControls() {
    if (this.controlsPlaceholder) return;
    this.controlsPlaceholder = document.createElement('div');
    this.siteHeaderHeight = document.querySelector(this.selectors.siteHeader).offsetHeight;
    this.controlsPlaceholder.style.height = `${this.controls.offsetHeight}px`;
    this.controlsPlaceholder.style.display = "none";

    this.controls.parentNode.insertBefore(this.controlsPlaceholder, this.controls);
  }

  initEvents() {
    this.tabs.forEach(t => t.addEventListener('tabChange', this.onTabChange));
    this.videos.forEach(v => v.addEventListener('loadeddata', this.onVideoLoaded));
    this.videos.forEach(v => v.addEventListener('timeupdate', this.onVideoTimeUpdated));
    this.videos.forEach(v => v.addEventListener('ended', this.onVideoEnded));
    this.mqlSmall.addEventListener('change', this.manageScrollEvent);
    
  }

  manageScrollEvent = (e) => {
    if (this.mqlSmall.matches) {
      this.setupControls();
      window.addEventListener('scroll', this.throttledOnScroll);
    } else {
      window.removeEventListener('scroll', this.throttledOnScroll);
    }
  }
  
  onScroll = (e) => {
    const topThreshold = (this.controls.classList.contains(this.classes.isFixed) ? this.controlsPlaceholder.offsetTop : this.controls.offsetTop) - this.siteHeaderHeight;
    if (window.scrollY >= topThreshold) {
      this.controls.classList.add(this.classes.isFixed);
      this.controlsPlaceholder.style.display = "block";
    } else {
      this.controls.classList.remove(this.classes.isFixed);
      this.controlsPlaceholder.style.display = "none";
    }
  }

  onTabChange = (e) => {
    const tabToggler = e.detail.tabTogglers[0];
    const collectionHandle = tabToggler.dataset[this.data.collectionHandle];
    const sectionId = this.dataset[this.data.section];

    this.playVideo(collectionHandle);
    this.tabs.forEach(t => { if (t != e.currentTarget) t.openTab(collectionHandle, false) });

    publish(PUB_SUB_EVENTS.collectionChange, {
      data: {
        sectionId: sectionId,
        collectionHandle: collectionHandle
      }
    });

  }

  openTabs(collectionHandle) {
    this.tabs.forEach(t => {
      t.openTab(collectionHandle, false);
    });
  }

  playCurrentVideo = () => {
    if (!this.currentVideo.classList.contains(this.classes.active)) {
      this.currentVideo
        .classList.add(this.classes.active);
      
    }

    this.currentVideo.playbackRate = this.videoPlaybackRate;
    this.currentVideo.play();
    this.previousVideo = this.currentVideo;
    this.videoIsPlaying = true;
  }
  
  onVideoLoaded = () => {
    if (
      this.previousVideo &&
      this.previousVideo != this.currentVideo
    ) {
      this.previousVideo
        .classList.remove(this.classes.active);
      
    }
    
    this.playCurrentVideo();
    
  }

  onVideoTimeUpdated = () => {
    if(this.videoIsFinishing) return;
    const buffer = 1 / (1 + (this.videoPlaybackRate - 1) * 0.3);
    
    if(this.currentVideo.currentTime - buffer >= this.currentVideo.duration / 2) {
      this.currentVideo.pause();
      this.videoIsPlaying = false;
      this.videoIsFinishing = true;
      
    }
    
  }
  
  onVideoEnded = () => {
    this.videoIsFinishing = false;
    this.videoIsPlaying = false;

    if (this.currentVideo) {
      if (
        this.previousVideo &&
        this.previousVideo != this.currentVideo
      ) {
        this.currentVideo.load();
      } else {
        this.playCurrentVideo();
      }
    }
    
  }

  playVideo(collectionHandle) {
    this.currentVideo = !collectionHandle ? this.currentVideo : this.videos.find(v => v.dataset[this.data.collectionHandle] == collectionHandle);
    
    if (!this.currentVideo) return;
    
    if (this.previousVideo) {
      this.previousVideo.play();
    } else {
      this.currentVideo.load();
    }
    
  }
  
}

customElements.define('mc-media-with-content', MCMediaWithContent);